import { IAction } from '../../../interface/action/action.interface';
import { ISendEmailPayload } from '../../../interface/action/browser-action.interface';
import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';

export const sendEmail = (email: string,
                          subject?: string,
                          body?: string
): IAction<ISendEmailPayload> => returnAction(ActionEnum.SEND_EMAIL, {email, subject, body}, true);
